/**
 * @file Overwrites the staged process document at
 * `<fileFolder>/process/<n>.json` with the user-edited copy (base proposal +
 * `decisions` overlay built by `buildEditedProcessDocument`). Called once, at
 * approve time — the apply tools re-read the document only at execution, so
 * intermediate writes buy nothing and a failed save must block the
 * `approvalResolved` POST. Mirrors the `uploadBytes` idiom of
 * `uploadTempAttachment`.
 */
import { ref, uploadBytes } from 'firebase/storage';
import { pathForStage } from '#types';
import type { ProcessDocument } from '#types';
import { storage } from '../services/startStorage';

export async function saveProcessDocument(
  fileFolder: string,
  processIndex: number,
  doc: ProcessDocument,
): Promise<void> {
  const path = pathForStage(fileFolder, 'process', { index: processIndex });
  const blob = new Blob([JSON.stringify(doc)], { type: 'application/json' });
  await uploadBytes(ref(storage, path), blob, { contentType: 'application/json' });
}
